import Link from '@splunk/react-ui/Link';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    margin: 10px 0;
`;

const AlertMessageLink = styled(Link)`
    margin: 0 4px;
`;

export default function CustomizeAlertLink() {
    return (
        <Container>
            {' '}
            To learn more, see how to
            <AlertMessageLink
                to="https://quickdraw.splunk.com/redirect/?product=Observability&location=apm.detector.learnmore&version.current"
                openInNewContext
            >
                customize notifications
            </AlertMessageLink>{' '}
        </Container>
    );
}
